export enum PopoverPlacements {
  Top = 'top',
  Bottom = 'bottom',
  Right = 'right',
  Left = 'left',
}

export enum PopoverVariants {
  Default = 'default',
  Segmented = 'segmented',
}

export const popoverPortalIdAttribute = 'data-portal-id';

// horizontal alignment of the popover with trigger (or anchor) when placement is 'top' or 'bottom'
// default is 'center'
export enum PopoverAlignment {
  Left = 'start',
  Center = 'center',
  Right = 'end',
}
